import {NavLink, useLocation} from "react-router-dom";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from "@mui/icons-material/Person";
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import CalculateIcon from '@mui/icons-material/Calculate';
import PeopleIcon from '@mui/icons-material/People';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import ViewListIcon from '@mui/icons-material/ViewList';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import React from "react";
import {useAuthContext} from "../../contexts/AuthContext";
import {useUserContext} from "../../contexts/UserContext";
import {useMediaQuery} from "react-responsive";
import {barHeight} from "./AppMobileNav";
import {mediaQueryForMobile} from "./HomePage";
import {useCalcContext} from "../../contexts/CalcContext";
import {NotificationsNavLink} from "../Notifications/NotificationsNavLink";

export const AppNavLinks = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { logout } = useAuthContext()
    const { profileState, isFeatureFlagEnabled, canDesk } = useUserContext()
    const { resetCalcState } = useCalcContext()
    let location = useLocation();
    const pathname = location.pathname
    const pathnameSplit = pathname.split('/')[1]

    const isPricingPath = pathnameSplit === 'pricing'
    const isCalculatePath = pathnameSplit === 'calculate'
    const isCRMPath = pathnameSplit === 'leads' || pathnameSplit === 'clients'
    const isPipelinePath = pathnameSplit === 'crm'

    const lastPricingRoute = () => {
        return profileState?.pages_visited?.find((route) => route.includes('/pricing/')) || '/pricing/honda'
    }

    return (
        <div className={'AppNavLinks'}>
            {
                isTabletOrMobile ? <div style={{height: `${barHeight}px`}}></div> : null
            }
            <div className={'AppSidebarNav-top'}>
                <div className={'navlink-container'}>
                    {
                        // Both of these pages exist only to price a deal, so a
                        // role that may not desk has no use for either. Routes
                        // guard them too — this just stops offering them.
                        canDesk() &&
                        <NavLink
                            onClick={() => {
                                if (isCalculatePath) {
                                    resetCalcState()
                                }
                            }}
                            to="/calculate"
                            className={({ isActive, isPending, isTransitioning }) =>
                                [
                                    "navlink",
                                    isPending ? "pending" : "",
                                    isActive ? "active" : "",
                                    isTransitioning ? "transitioning" : "",
                                ].join(" ")
                            }
                        >
                            <CalculateIcon/> <span>Calculate</span>
                        </NavLink>
                    }
                    <NavLink
                        to="/quotes"
                        className={({ isActive, isPending, isTransitioning }) =>
                            [
                                "navlink",
                                isPending ? "pending" : "",
                                isActive ? "active" : "",
                                isTransitioning ? "transitioning" : "",
                            ].join(" ")
                        }
                    >
                        <RequestQuoteIcon/> <span>Quotes</span>
                    </NavLink>
                    {
                        canDesk() &&
                        <NavLink
                            to={lastPricingRoute()}
                            className={({ isActive, isPending, isTransitioning }) =>
                                [
                                    "navlink",
                                    isPending ? "pending" : "",
                                    isPricingPath ? "active" : "",
                                    isTransitioning ? "transitioning" : "",
                                ].join(" ")
                            }
                        >
                            <ViewListIcon/> <span>Pricing Index</span>
                        </NavLink>
                    }
                    {
                        isFeatureFlagEnabled('listings') &&
                        <NavLink
                            to="/listings"
                            className={({ isActive, isPending, isTransitioning }) =>
                                [
                                    "navlink",
                                    isPending ? "pending" : "",
                                    isActive ? "active" : "",
                                    isTransitioning ? "transitioning" : "",
                                ].join(" ")
                            }
                        >
                            <DirectionsCarFilledIcon/> <span>Listings</span>
                        </NavLink>
                    }
                    {
                        isFeatureFlagEnabled('crm') && !isTabletOrMobile &&
                        <NavLink
                            to="/leads"
                            className={({ isActive, isPending, isTransitioning }) =>
                                [
                                    "navlink",
                                    isPending ? "pending" : "",
                                    isCRMPath ? "active" : "",
                                    isTransitioning ? "transitioning" : "",
                                ].join(" ")
                            }
                        >
                            <PeopleIcon/> <span>CRM</span>
                        </NavLink>
                    }
                    {
                        isFeatureFlagEnabled('pipeline') &&
                        <NavLink
                            to="/crm/pipeline"
                            className={({ isActive, isPending, isTransitioning }) =>
                                [
                                    "navlink",
                                    isPending ? "pending" : "",
                                    isPipelinePath ? "active" : "",
                                    isTransitioning ? "transitioning" : "",
                                ].join(" ")
                            }
                        >
                            <ViewKanbanIcon/> <span>Pipeline</span>
                        </NavLink>
                    }
                </div>

            </div>
            <div className={'AppSidebarNav-bottom'}>
                {
                    isFeatureFlagEnabled('notifications') &&
                    <NotificationsNavLink/>
                }
                {
                    // Quote defaults, which only ever apply through a scan.
                    canDesk() &&
                    <NavLink
                        to="/quote-settings"
                        className={({ isActive, isPending, isTransitioning }) =>
                            [
                                "navlink",
                                isPending ? "pending" : "",
                                isActive ? "active" : "",
                                isTransitioning ? "transitioning" : "",
                            ].join(" ")
                        }
                    >
                        <SettingsSuggestIcon/> <span>Settings</span>
                    </NavLink>
                }
                <NavLink
                    to="/account/profile"
                    className={({ isActive, isPending, isTransitioning }) =>
                        [
                            "navlink",
                            isPending ? "pending" : "",
                            isActive ? "active" : "",
                            isTransitioning ? "transitioning" : "",
                        ].join(" ")
                    }
                >
                    <PersonIcon/> <span>Profile</span>
                </NavLink>
                <div className={'navlink'} onClick={() => logout()}>
                    <LogoutIcon/> <span>Log out</span>
                </div>
            </div>
        </div>
    )
}